import DatePickerLocale from 'rmc-date-picker/es/locale/zh_CN';
export default {
    okText: '确定',
    dismissText: '取消',
    extra: '请选择',
    DatePickerLocale: DatePickerLocale
};